import { render, staticRenderFns } from "./workshopdetails2.vue?vue&type=template&id=8c036c34&"
import script from "./workshopdetails2.vue?vue&type=script&lang=js&"
export * from "./workshopdetails2.vue?vue&type=script&lang=js&"
import style0 from "./workshopdetails2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports